import React from 'react';
import Phone from '@material-ui/icons/PhoneOutlined';
import Wifi from '@material-ui/icons/WifiOutlined';
import { HeadingSBold, BodyS } from 'components/Typography/Typography';
import styles from 'assets/jss/material-dashboard-pro-react/views/settingsSubpageStyle';
import { makeStyles } from '@material-ui/core';
// @ts-ignore
const useStyles = makeStyles(styles);

interface INumberInfoProps {
	phoneNumber: string;
	accountDetails: string;
	withData?: boolean;
}

const NumberInfo = ({ phoneNumber, accountDetails, withData = false }: INumberInfoProps) => {
	const classes = useStyles();
	return (
		<div className={classes.numberInfo}>
			{withData ? <Wifi /> : <Phone />}
			<div>
				<HeadingSBold>{phoneNumber}</HeadingSBold>
				<BodyS>{accountDetails}</BodyS>
			</div>
		</div>
	);
};

export default NumberInfo;
